import React from 'react';
import parse from 'html-react-parser';
import DataLoader from "../../components/loader/dataLoader";
import '../../assets/css/pages/about/style.scss';
import useAbout from "../../hooks/public/useAbout";

const Index = () => {
    const { data, isLoading } = useAbout();

    // Safely access `description` and replace `&nbsp;` if it exists
    const description = data?.description
        ? data.description.replace(/&nbsp;/g, ' ')
        : '';

    return (
        <section id="about" className="about">
            <div className="custom-container">
                <div className="content-section">
                    <h1 className="page-title">About Us</h1>
                    <div className="content-body">
                        <h2 className="content___body-title mb-3">
                            Customs Bond Commissionerate (CBC)
                        </h2>
                        <div className="content">
                            {isLoading && <DataLoader />}
                            {!isLoading && description && parse(description)}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Index;
